import { Skin } from '@/core/interfaces';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface SkinsState {
	selected: Skin;
	skins: Skin[];
	active: Skin | null;
	activePage: string;
}
/**
 *
 * Skins slice of the redux store.
 * It contains the state of the selected skin and the list of all skins.
 * It also contains the reducers for setting the selected skin and the list of all skins.
 *
 * selected: Is the sking that the user has
 * active: Is for navigation purposes, indicates the page that the user is currently on
 */
const skinsSlice = createSlice({
	name: 'skins',
	initialState: {
		selected: {
			id: '',
			name: '',
			cover: '',
			price: 0,
			owned: false,
			selected: false,
			expired: false,
			images: [],
			imageExtension: '',
		},
		active: null,
		activePage: '',
		skins: [],
	} as SkinsState,
	reducers: {
		setSelectedSkin: (state, action: PayloadAction<Skin>) => {
			debugger;
			if (state.active) {
				state.active.selected = true;

				state.selected = {
					id: action.payload.id,
					name: action.payload.name,
					cover: action.payload.cover,
					price: action.payload.price,
					owned: action.payload.owned,
					selected: true,
					expired: state.active.expired,
					images: action.payload.images,
					imageExtension: action.payload.imageExtension,
				};
			}

			const filteredSkin = state.skins.find(
				(skin) => skin.id === action.payload.id
			);
			if (filteredSkin) {
				filteredSkin.selected = true;
			}
		},
		setDeselectSkin: (state) => {
			debugger;

			if (state.active) {
				state.active.selected = false;

				state.selected = {
					id: '',
					name: '',
					cover: '',
					price: 0,
					owned: true,
					selected: false,
					expired: state.active.expired,
					images: [],
					imageExtension: '',
				};

				const filteredSkin = state.skins.find(
					(skin) => skin.id === state.active!.id
				);

				if (filteredSkin) {
					filteredSkin.selected = false;
				}
			}
		},
		setSkins: (state, action: PayloadAction<Skin[]>) => {
			state.skins = action.payload;
		},
		setActivePage: (state, action: PayloadAction<string | null>) => {
			const active = state.skins.find(
				(skin) => skin.id === action.payload
			);

			if (active) {
				state.activePage = active.id;
				state.active = active;
			}
		},
		setActiveSkin: (state, action: PayloadAction<Skin>) => {
			const activeskin = state.skins.find(
				(skin) => skin.id === action.payload.id
			);
			if (activeskin) {
				state.active = activeskin;
			}
		},
		setPurchasedSkin: (state, action: PayloadAction<Skin>) => {
			// Set as purchased in skin list
			const skin = state.skins.find(
				(skin) => skin.id === action.payload.id
			);
			if (skin) {
				skin.owned = true;
			}

			// Set as purchased in current/active skin
			if (state.active) {
				state.active.owned = true;
			}
		},
	},
});

const { reducer, actions } = skinsSlice;

export const {
	setSelectedSkin,
	setDeselectSkin,
	setSkins,
	setActiveSkin,
	setPurchasedSkin,
	setActivePage,
} = actions;
export default reducer;
